/**
 * Feature Management API Service
 * 
 * Handles all API calls related to feature flags and modules
 */
import { apiService as api } from './api.service';

// API endpoints
const ENDPOINTS = {
  // Module management
  MODULES: '/features/modules',
  MODULE_FEATURES: (moduleId) => `/features/module/${moduleId}/features`,
  
  // Feature management
  REGISTER_MODULE: '/features/register-module',
  REGISTER_FEATURE: '/features/register',
  
  // Tenant features
  TENANT_FEATURES: (tenantAlias) => `/features/tenant/${tenantAlias}/features`,
  UPDATE_TENANT_FEATURES: (tenantAlias) => `/features/tenant/${tenantAlias}/update`,
  
  // Developer features
  DEVELOPER_FEATURES: (developerId) => `/features/developer/${developerId}/features`,
  
  // Feature codes
  TENANT_FEATURE_CODES: (tenantAlias) => `/features/${tenantAlias}/feature-codes`,
  
  // All features
  ALL_FEATURES: '/features/featurelist'
};

/**
 * Feature Management API functions
 */
export const featureManagementService = {
  // Module management
  getModules: () => api.get(ENDPOINTS.MODULES),
  getModuleFeatures: (moduleId) => api.get(ENDPOINTS.MODULE_FEATURES(moduleId)),
  
  // Feature registration
  registerModule: (moduleData) => api.post(ENDPOINTS.REGISTER_MODULE, moduleData),
  registerFeature: (featureData) => api.post(ENDPOINTS.REGISTER_FEATURE, featureData),
  
  // Tenant features
  getTenantFeatures: (tenantAlias) => api.get(ENDPOINTS.TENANT_FEATURES(tenantAlias)),
  updateTenantFeatures: (tenantAlias, featuresData) => 
    api.post(ENDPOINTS.UPDATE_TENANT_FEATURES(tenantAlias), { features: featuresData }),
  
  // Developer features
  getDeveloperFeatures: (developerId) => api.get(ENDPOINTS.DEVELOPER_FEATURES(developerId)),
  
  // Feature codes
  getTenantFeatureCodes: (tenantAlias) => api.get(ENDPOINTS.TENANT_FEATURE_CODES(tenantAlias)),
  
  // All features
  getAllFeatures: () => api.get(ENDPOINTS.ALL_FEATURES)
}; 